<template>
    <b-modal id="addMemberNotesModal" modal-class="client-details-modal" centered size="md" hide-footer
        no-close-on-backdrop hide-header-close>
        <!-- Modal Header -->
        <template #modal-header>
            <div class="view-clients-header">
                <h5 class="modal-title text-center">Create Note</h5>
                <b-button variant="close-btn" class="btn-container" @click="closeModal">
                    <i class="fas fa-times"></i>
                </b-button>
            </div>
        </template>

        <b-container>
            <div class="form-part">
                <!-- NOTE INPUT -->
                <div class="mb-3">
                    <label for="noteInput">Notes <span class="text-danger">*</span></label>
                    <textarea id="noteInput" class="memberSearch-field w-100 mt-2" rows="4" v-model="note"
                        @input="noteError = ''" placeholder="Enter your note here..."></textarea>
                    <div v-if="noteError" class="form-error error-font-size mt-2">
                        {{ noteError }}
                    </div>
                </div>

                <div class="mb-3">
                    <label for="noteInput">Mark Note As <span class="text-danger">*</span></label>
                    <select id="noteInput" class="memberSearch-field mark-fiels w-100 mt-2" v-model="status">
                        <option value="" selected>mark the note</option>

                        <option v-for="(item, key) in statusColors" :key="key" :value="item.value"
                            :style="{ color: item.color, fontWeight: 'bold' }">
                            {{ key }}
                        </option>

                    </select>

                    <div v-if="markError" class="form-error error-font-size mt-2">
                        {{ markError }}
                    </div>
                </div>


                <!-- FILE UPLOAD -->
                <div class="mb-3">
                    <label>Attachments <span class="text-muted">(optional)</span></label>
                    <div class="file-upload-container mt-2" :class="{ 'drag-over': isDragOver }"
                        @click="triggerFileInput" @dragover.prevent="onDragOver" @dragleave.prevent="onDragLeave"
                        @drop.prevent="onDrop">
                        <i class="fas fa-upload upload-icon"></i>
                        <span>Click or drag & drop a file here</span>
                        <input type="file" ref="fileInput" class="d-none" @change="handleFile"
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.csv" />
                    </div>
                    <div class="text-muted small mt-1">
                        Maximum file size: 4MB. Allowed types: pdf, doc, docx, xls, xlsx, csv.
                    </div>
                    <div v-if="fileName" class="mt-2 file-view-template">
                        <span>
                            {{ fileName }}
                        </span>
                        <i class="fa fa-trash excel-trash-icon" @click="removeFile"></i>
                    </div>
                </div>

                <!-- SAVE BUTTON -->
                <div class="notes-action-btns d-flex justify-content-end flex-column flex-md-row mt-4 gap-2">
                    <button class="group-univ-btn m-0" @click="saveNote" :disabled="isLoading">
                        {{ isLoading ? "Saving..." : "Submit" }}
                    </button>
                    <b-button variant="outline-secondary" @click="closeModal">Close</b-button>
                </div>
            </div>
        </b-container>
    </b-modal>
</template>

<script>
// import Api from "@/resource/Api";
import { mapGetters } from 'vuex/dist/vuex.common.js';
import axios from 'axios';
import Helper from '../../../../resource/Helper';
export default {
    name: "AddMemberNotesModal",
    props: {
        isOpen: Boolean,
        row: { type: Object, default: () => { } },

    },
    data() {
        return {
            note: "",
            noteError: "",
            file: null,
            fileName: "",
            isLoading: false,
            isDragOver: false,
            markError: "",
            status: "",
            statusColors: {
                Urgent: { color: "#FF0000", value: 1 },
                Important: { color: "#FF8000", value: 2 },
                High: { color: "#FFC300", value: 3 },
                Medium: { color: "#800000", value: 4 },
                Low: { color: "#0000FF", value: 5 },
                Information: { color: "#00A000", value: 6 },
                Special: { color: "#FF69B4", value: 8 }
            },
            nueraNoteUrl: process.env.VUE_APP_API_ADMIN,
        };
    },
    watch: {
        isOpen(val) {
            if (val) this.$bvModal.show("addMemberNotesModal");
            this.status = "";
        },
    },
    methods: {
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleFile(e) {
            const f = e.target.files[0];
            if (f) {
                this.file = f;
                this.fileName = f.name;
            }
        },
        removeFile() {
            this.file = null;
            this.fileName = "";
        },
        onDragOver() {
            this.isDragOver = true;
        },
        onDragLeave() {
            this.isDragOver = false;
        },
        onDrop(e) {
            this.isDragOver = false;
            const f = e.dataTransfer.files[0];
            if (f) {
                this.file = f;
                this.fileName = f.name;
            }
        },
        resetState() {
            this.note = "";
            this.file = null;
            this.fileName = "";
            this.noteError = "";
            this.markError = "";
        },
        async saveNote() {
            if (!this.note.trim()) {
                this.noteError = "Note is required.";
                return;
            }

            if (!this.status) {
                this.markError = "The mark note as field is required";
                return;
            }

            const formData = new FormData();
            formData.append("note", this.note);
            formData.append("policy_id", this.row.policy_id);
            formData.append("status", this.status);
            formData.append("source", "rep");
            formData.append('username', this.rep.name);
            formData.append('agent_id', this.repCode);
            formData.append('is_root', this.isRoot ? 1 : 0);


            if (this.file) formData.append("file", this.file);

            this.isLoading = true;
            const loader = this.$loading.show();
            const url = this.nueraNoteUrl + '/api/v1/add-notes'
            // Api.post("v2/add-notes", formData)   
            await axios.post(url, formData, {
                headers: {
                    "X-Internal-Token": Helper.nueraProtectedApiToken(),
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(() => {
                    this.$notify("Note added successfully.");
                    this.$emit("noteAdded");
                    this.closeModal();
                })
                .catch((err) => {
                    this.$notify(err.response?.data?.message || "Failed to add note.", "error");
                })
                .finally(() => {
                    this.isLoading = false;
                    loader.hide();
                });
        },
        closeModal() {
            this.resetState();
            this.$bvModal.hide("addMemberNotesModal");
            this.$emit("close");
        },
    },
    computed: {
        ...mapGetters({
            rep: "rep",
        }),
        isRoot() {
            return this.$store.getters.rootUser;
        },
        repCode() {
            return this.$store.getters.rep.id;
        },
        repName() {
            return this.$store.getters.rep.name;
        },
        repEmail() {
            // return this.$store.getters.rep.email;
            return this.$store.getters.repEmail;
        },
    }
};
</script>

<style scoped>
.file-upload-container {
    border: 2px dashed #ccc;
    border-radius: 5px;
    padding: 1.25em;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.3s, background-color 0.3s;
}

.file-upload-container.drag-over {
    border-color: #0d6efd;
    background-color: #e7f1ff;
}

.upload-icon {
    font-size: 1.5rem
}

.file-view-template {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
}

.file-view-template span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.notes-action-btns button {
    min-width: 100px;
}

@media (max-width:576px) {
    .notes-action-btns button {
        width: 100%;
        max-width: none;
        margin-bottom: 0.5rem;
    }
}
</style>
